import { render, staticRenderFns } from "./SoftbookVersionSelectDropdown.vue?vue&type=template&id=1ac33183&"
import script from "./SoftbookVersionSelectDropdown.ts?vue&type=script&lang=ts&"
export * from "./SoftbookVersionSelectDropdown.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SoftbookVersionSelectDropdown.vue"
export default component.exports